import { combineReducers } from 'redux';

import common from "./common";
import category from "./category";
import product from "./product";
import productFile from "./product-file";
import productSimilar from "./product-similar";
import productSpec from "./product-spec";
import productBrandPrice from "./product-brand-price";
import customProductSpec from "./custom-product-spec";
import customProduct from "./custom-product";
import bulkEdit from "./bulk-edit";
import specCategory from "./spec-category";
import spec from "./spec";
import specValue from "./spec-value";
import brand from "./brand";
import brandDiscount from "./brand-discount";
import brandFile from "./brand-file";
import setting from "./setting";
import bankAccount from "./bank-account";
import postalMethod from "./postal-method";
import paymentMethod from "./payment-method";
import bankGateway from "./bank-gateway";
import keyword from "./keyword";
import fcm from "./fcm";
import mobileImageSlider from "./mobile-image-slider";
import websiteImageSlider from "./website-image-slider";
import role from "./role";
import user from "./user";
import page from "./page";
import specialOrder from "./special-order";
import userCredit from "./user-credit";
import order from "./order";
import userAddress from "./user-address";
import preInvoice from "./pre-invoice";

const combinedReducers = combineReducers({
    common,
    category,
    product,
    productFile,
    productSimilar,
    productSpec,
    productBrandPrice,
    customProductSpec,
    customProduct,
    bulkEdit,
    specCategory,
    spec,
    specValue,
    brand,
    brandDiscount,
    brandFile,
    setting,
    bankAccount,
    postalMethod,
    paymentMethod,
    bankGateway,
    keyword,
    fcm,
    role,
    user,
    page,
    specialOrder,
    userCredit,
    mobileImageSlider,
    websiteImageSlider,
    order,
    userAddress,
    preInvoice
});

export default (state, action) => {
    if (action.type === 'RESET_STORE') state = undefined;

    return combinedReducers(state, action);
}